/**
 * Profile templates expose curated, ordered bundles of data point IDs that
 * client code (e.g. integrations, onboarding flows) can reference by id
 * instead of hard-coding lists of data points in multiple places.
 *
 * Flat constants object (Option A): each template is a top-level entry in
 * PROFILE_TEMPLATES keyed by its id (which also lives in PROFILE_TEMPLATE_IDS
 * for type-safe enumeration in TypeScript consumers).
 */

export const PROFILE_TEMPLATE_IDS = {
  AMFORI_INTEGRATION: 'AMFORI_INTEGRATION',
}

export const PROFILE_TEMPLATES = {
  AMFORI_INTEGRATION: {
    id: 'AMFORI_INTEGRATION',
    dataPointIds: [
      'amfori_client_id',
      'amfori_client_secret',
      'amfori_credentials_verified_at',
      'amfori_member_id',
      'amfori_site_ids',
      'amfori_last_synced_at',
      'amfori_credentials_revoked_at',
    ],
  },
}
